import { render, staticRenderFns } from "./createLazada.vue?vue&type=template&id=05b8964a&scoped=true"
import script from "./createLazada.vue?vue&type=script&lang=js"
export * from "./createLazada.vue?vue&type=script&lang=js"
import style0 from "./createLazada.vue?vue&type=style&index=0&id=05b8964a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b8964a",
  null
  
)

export default component.exports